import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/vercel/path0/layouts/minimal.vue").then(m => m.default || m))
}